<template>
    <div v-if="user">
        <!-- <pdf src="./assets/img/inspecta2.pdf"></pdf> -->
        <!-- <pdf
            v-for="i in numPages"
            :key="i"
            :src="src"
            :page="i"
            style="display: inline-block; width: 100%"
            @link-clicked="page = $event">
        </pdf> -->
    </div>
    <div v-else>
      <b-alert show fade>Debe logearse al sistema</b-alert>
    </div>
</template>
<script>
// import pdf from 'vue-pdf'
// import { mapState, mapActions } from 'vuex'

// var loadingTask = pdf.createLoadingTask('./static/doc/inspecta2.pdf')

export default {
  // components: {
  //   pdf
  // },
  // data () {
  //   return {
  //     src: loadingTask,
  //     page: 1,
  //     numPages: undefined
  //   }
  // },
  // mounted () {
  //   this.src.then(pdf => {
  //     this.numPages = pdf.numPages
  //   })
  // },
  // computed: {
  //   ...mapState([
  //     'user'
  //   ])
  // },
  // methods: {
  //   ...mapActions([
  //     'setMessage'
  //   ])
  // }
}
</script>
